export const FLIGHT_STATUS = {
  LOADING: 'Loading',
  IN_TREATMENT: 'InTreatment',
  IN_CONTROL: 'InControl',
  NOT_IN_FLIGHT: 'NotInFlight',
} as const;
